/**
 * Initial metrics range of the Flows tab (FlowConfigTab), from the preset and
 * custom bounds its parent passes. Moved out of FlowConfigTab unchanged.
 * For Media Devoted | Created By Ciro Autiero
 */

import { getRangeFromPreset } from '@/components/date-range';
import type { StatsDateRangePreset } from '@/components/date-range';

export function resolveInitialRange(
  preset: string | undefined,
  customFrom: string | undefined,
  customTo: string | undefined,
): { from: string; to: string } {
  if (preset === 'custom' && customFrom && customTo) {
    return { from: customFrom, to: customTo };
  }
  const code = (preset ?? 'last-7-days') as StatsDateRangePreset;
  return (
    getRangeFromPreset(code) ?? getRangeFromPreset('last-7-days')!
  );
}

export function resolveInitialPreset(
  preset: string | undefined,
  customFrom: string | undefined,
  customTo: string | undefined,
): StatsDateRangePreset {
  if (preset === 'custom' && customFrom && customTo) return 'custom';
  return (preset ?? 'last-7-days') as StatsDateRangePreset;
}
